import { render, staticRenderFns } from "./top.vue?vue&type=template&id=1310b470&scoped=true&"
import script from "./top.vue?vue&type=script&lang=js&"
export * from "./top.vue?vue&type=script&lang=js&"
import style0 from "./top.vue?vue&type=style&index=0&lang=css&"
import style1 from "./top.vue?vue&type=style&index=1&id=1310b470&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1310b470",
  null
  
)

export default component.exports